import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";

import { saveRefFromUrl } from "./lib/referral";
import { AppRoutes } from "./router";
import { AuthProvider } from "./contexts/AuthContext";
import { DeliveryDataProvider } from "./contexts/DeliveryDataContext";
import { ShiftProvider } from "./contexts/ShiftContext";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";

/**
 * Root component of the application.
 * Wraps the routing and all required context providers.
 */
function App() {
  useEffect(() => {
    saveRefFromUrl();
  }, []);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <SubscriptionProvider>
          <DeliveryDataProvider>
            <ShiftProvider>
              <AppRoutes />
            </ShiftProvider>
          </DeliveryDataProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;